//Creates new Timer and assigns ID and type
export const createTimer = (data) => {
    //data = {id, type}
    return { type: "CREATE_TIMER", payload: data}
}

export const setTimerShowPopup = (data) => {
    return { type: "SET_TIMER_SHOW_POPUP", payload: data}
}

export const setTimerRunning = (data) => {
    return { type: "SET_TIMER_RUNNING", payload: data}
}

export const setTimerTime = (data) => {
    return { type: "SET_TIMER_TIME", payload: data}
}

export const onTimerClickDone = (data) => {
    return { type: "ON_TIMER_CLICK_DONE", payload: data}
}